import React from 'react';
import { Grid, Typography, Box, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';

import DetailsRow from '../../../../shared/components/UI/DetailsRow';

const SIGNATURE_PERMISSION_MODES = [
  { id: 1, title: 'Users with Sign and Send Permission' },
  { id: 2, title: 'Specific Users' },
  { id: 3, title: 'Anyone Can Sign' }
];

const ReadonlySignaturePermissionSection = ({ 
  signaturePermissionMode, 
  allowedSigners, 
  specificSigners 
}) => {
  const getModeTitle = (mode) => {
    const modeConfig = SIGNATURE_PERMISSION_MODES.find(m => m.id === mode);
    return modeConfig ? modeConfig.title : 'Unknown Mode';
  };

  const renderUserTable = (users, emptyMessage) => {
    if (!users || !users.edges || users.edges.length === 0) {
      return (
        <Typography variant="body2" color="textSecondary">
          {emptyMessage}
        </Typography>
      );
    }

    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>User Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.edges.map(edge => (
            <TableRow key={edge.node.id}>
              <TableCell>{edge.node.user.fullName}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h3" gutterBottom>
          Signature Permissions
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <DetailsRow 
          title="Restrict To" 
          content={getModeTitle(signaturePermissionMode)} 
        />
      </Grid>

      {/* Mode 1: Show Allowed Signers (exception list) */}
      {signaturePermissionMode === 1 && (
        <Grid item xs={12}>
          <Typography variant="h3" gutterBottom>
            Allowed Signers
          </Typography>
          <Typography variant="caption" color="textSecondary" gutterBottom>
            Users who can sign without 'Sign and Send' permission
          </Typography>
          {renderUserTable(allowedSigners, "No Allowed Signers configured")}
        </Grid>
      )}

      {/* Mode 2: Show Specific Signers (restricted list) */}
      {signaturePermissionMode === 2 && (
        <Grid item xs={12}>
          <Typography variant="h3" gutterBottom>
            Specific Signers
          </Typography>
          <Typography variant="caption" color="textSecondary" gutterBottom>
            Only these users can sign contracts
          </Typography>
          {renderUserTable(specificSigners, "No Specific Signers configured")}
        </Grid>
      )}

      {/* Mode 3: Show explanatory text */}
      {signaturePermissionMode === 3 && (
        <Grid item xs={12}>
          <Box mt={1}>
            <Typography variant="caption" color="textSecondary">
              All users in your organization will be able to sign contracts using this template.
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

ReadonlySignaturePermissionSection.propTypes = {
  signaturePermissionMode: PropTypes.number.isRequired,
  allowedSigners: PropTypes.object,
  specificSigners: PropTypes.object
};

export default ReadonlySignaturePermissionSection;
